<template>
  <div v-if="visible" class="M-prompt fb fb-main-center fb-cross-center ">
    <div class="card bd-radio-8 bg-FFFFFF">
      <div class="content p-0-20 pt-20">
        <div class="font-34 c-171A1D mb-16 text-center">
          {{ title }}
        </div>
        <!-- 输入框 -->
        <div
          class="w-full h-44 lh-44 p-0-16 fb fb-main-center fb-cross-center bd-radio-9999 bg-171A1D-8 mb-16"
        >
          <input
            class="w-full h-full bg-transparent font-34"
            :value="value"
            type="text"
            @input="handlerInput"
            @focus="handlerFocus"
            @blur="handlerBlur"
            :maxlength="maxlength"
            :placeholder="placeholder"
          />
          <span
            v-show="!!value"
            @click="handlerToClearValue"
            class="c-171A1D-40 font-32  iconfont"
            >&#xe670;</span
          >
        </div>
      </div>
      <!-- 按钮 -->
      <div class="h-48 fb fb-main-center bt">
        <span
          class="h-full lh-48 item-flex-1  br font-34 c-006AFE text-center"
          @click="handlerClick(1)"
        >
          {{ cancelText }}
        </span>
        <span
          class="h-full lh-48 item-flex-1  font-34 c-006AFE text-bold text-center"
          @click="handlerClick(2)"
        >
          {{ confirmText }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'commonPrompt',
  props: {
    visible: Boolean, // prompt是否显示
    value: [String, Number],
    // 标题文字
    title: {
      type: String,
      default: '提示'
    },
    // 取消按钮文字
    cancelText: {
      type: String,
      default: '取消'
    },
    // 确认按钮文字
    confirmText: {
      type: String,
      default: '确认'
    },
    // 输入框placeholder
    placeholder: {
      type: String,
      default: '请输入'
    },
    maxlength: Number
  },
  // data() {
  //   return {
  //     value: ''
  //   }
  // },
  computed: {},
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    init() {},
    // 按钮事件处理
    handlerClick(i) {
      if (i === 2) {
        this.$emit('handlerClick')
      } else {
        this.$emit('update:visible', false)
      }
    },
    handlerInput(e) {
      let _value = e.target.value
      this.$emit('input', _value, e)
    },
    handlerFocus(e) {
      let _value = e.target.value
      this.$emit('focus', _value)
    },
    handlerBlur(e) {
      let _value = e.target.value
      this.$emit('blur', _value)
    },
    handlerToClearValue(e) {
      this.$emit('clear', '')
    }
  },
  filters: {}
}
</script>

<style lang="scss" scoped>
.M-prompt {
  height: 100vh;
  width: 100%;
  position: absolute;
  background-color: rgba(0, 0, 0, 0.28);
  top: 0;
  z-index: 999;
  > .card {
    width: 280px;
    position: relative;
    top: -44px;
    input {
      border: none;
      display: block;
      width: 100%;
      background-color: transparent;
      caret-color: #006afe;
    }
  }
}
</style>
